/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CanPublishPlansParams,
  CancelGenerationParams,
  GetResultParams,
  GetStatusParams,
  GetStatusResponse,
  PlanScheduleDto,
  PlansExportParams,
  StartGenerationResponse,
  StartGenrationRequest
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetAvailablePlansUrl = () => {




  return `/api/Plans/GetAvailablePlans`
}

export const getAvailablePlans = async ( options?: Parameters<typeof customInstance>[1]): Promise<PlanScheduleDto[]> => {

  return customInstance<PlanScheduleDto[]>(getGetAvailablePlansUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAvailablePlansQueryKey = () => {
    return [
    `/api/Plans/GetAvailablePlans`
    ] as const;
    }


export const getGetAvailablePlansQueryOptions = <TData = Awaited<ReturnType<typeof getAvailablePlans>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailablePlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailablePlansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailablePlans>>> = ({ signal }) => getAvailablePlans({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAvailablePlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAvailablePlansQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailablePlans>>>
export type GetAvailablePlansQueryError = ErrorType<unknown>


export function useGetAvailablePlans<TData = Awaited<ReturnType<typeof getAvailablePlans>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailablePlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailablePlans>>,
          TError,
          Awaited<ReturnType<typeof getAvailablePlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailablePlans<TData = Awaited<ReturnType<typeof getAvailablePlans>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailablePlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailablePlans>>,
          TError,
          Awaited<ReturnType<typeof getAvailablePlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailablePlans<TData = Awaited<ReturnType<typeof getAvailablePlans>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailablePlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAvailablePlans<TData = Awaited<ReturnType<typeof getAvailablePlans>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailablePlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAvailablePlansQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAvailablePlansSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAvailablePlans>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailablePlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailablePlansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailablePlans>>> = ({ signal }) => getAvailablePlans({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailablePlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAvailablePlansSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailablePlans>>>
export type GetAvailablePlansSuspenseQueryError = ErrorType<unknown>


export function useGetAvailablePlansSuspense<TData = Awaited<ReturnType<typeof getAvailablePlans>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailablePlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailablePlansSuspense<TData = Awaited<ReturnType<typeof getAvailablePlans>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailablePlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailablePlansSuspense<TData = Awaited<ReturnType<typeof getAvailablePlans>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailablePlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAvailablePlansSuspense<TData = Awaited<ReturnType<typeof getAvailablePlans>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAvailablePlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAvailablePlansSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStartGenerationUrl = () => {




  return `/api/Plans/StartGeneration`
}

export const startGeneration = async (startGenrationRequest?: StartGenrationRequest, options?: Parameters<typeof customInstance>[1]): Promise<StartGenerationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<StartGenerationResponse>(getStartGenerationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startGenrationRequest)
  }
);}





export const getStartGenerationMutationKey = () => ['startGeneration'] as const;

export const getStartGenerationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startGeneration>>, TError,StartGenerationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof startGeneration>>, TError,StartGenerationMutationVariables, TContext> => {

const mutationKey = getStartGenerationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startGeneration>>, StartGenerationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  startGeneration(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartGenerationMutationResult = NonNullable<Awaited<ReturnType<typeof startGeneration>>>
    export type StartGenerationMutationBody = BodyType<StartGenrationRequest> | undefined
    export type StartGenerationMutationError = ErrorType<unknown>
    export type StartGenerationMutationVariables = {data?: BodyType<StartGenrationRequest>}

    export const useStartGeneration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startGeneration>>, TError,StartGenerationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startGeneration>>,
        TError,
        StartGenerationMutationVariables,
        TContext
      > => {
      return useMutation(getStartGenerationMutationOptions(options), queryClient);
    }
    export const getGetStatusUrl = (params?: GetStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Plans/GetStatus?${stringifiedParams}` : `/api/Plans/GetStatus`
}

export const getStatus = async (params?: GetStatusParams, options?: Parameters<typeof customInstance>[1]): Promise<GetStatusResponse> => {

  return customInstance<GetStatusResponse>(getGetStatusUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStatusQueryKey = (params?: GetStatusParams,) => {
    return [
    `/api/Plans/GetStatus`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStatusQueryOptions = <TData = Awaited<ReturnType<typeof getStatus>>, TError = ErrorType<unknown>>(params?: GetStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatusQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatus>>> = ({ signal }) => getStatus(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getStatus>>>
export type GetStatusQueryError = ErrorType<unknown>


export function useGetStatus<TData = Awaited<ReturnType<typeof getStatus>>, TError = ErrorType<unknown>>(
 params: undefined |  GetStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatus>>,
          TError,
          Awaited<ReturnType<typeof getStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatus<TData = Awaited<ReturnType<typeof getStatus>>, TError = ErrorType<unknown>>(
 params?: GetStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatus>>,
          TError,
          Awaited<ReturnType<typeof getStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatus<TData = Awaited<ReturnType<typeof getStatus>>, TError = ErrorType<unknown>>(
 params?: GetStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetStatus<TData = Awaited<ReturnType<typeof getStatus>>, TError = ErrorType<unknown>>(
 params?: GetStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStatusQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getStatus>>, TError = ErrorType<unknown>>(params?: GetStatusParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatusQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatus>>> = ({ signal }) => getStatus(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getStatus>>>
export type GetStatusSuspenseQueryError = ErrorType<unknown>


export function useGetStatusSuspense<TData = Awaited<ReturnType<typeof getStatus>>, TError = ErrorType<unknown>>(
 params: undefined |  GetStatusParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatusSuspense<TData = Awaited<ReturnType<typeof getStatus>>, TError = ErrorType<unknown>>(
 params?: GetStatusParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatusSuspense<TData = Awaited<ReturnType<typeof getStatus>>, TError = ErrorType<unknown>>(
 params?: GetStatusParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetStatusSuspense<TData = Awaited<ReturnType<typeof getStatus>>, TError = ErrorType<unknown>>(
 params?: GetStatusParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStatusSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetResultUrl = (params?: GetResultParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Plans/GetResult?${stringifiedParams}` : `/api/Plans/GetResult`
}

export const getResult = async (params?: GetResultParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getGetResultUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetResultQueryKey = (params?: GetResultParams,) => {
    return [
    `/api/Plans/GetResult`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetResultQueryOptions = <TData = Awaited<ReturnType<typeof getResult>>, TError = ErrorType<unknown>>(params?: GetResultParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResult>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResultQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResult>>> = ({ signal }) => getResult(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResult>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResultQueryResult = NonNullable<Awaited<ReturnType<typeof getResult>>>
export type GetResultQueryError = ErrorType<unknown>


export function useGetResult<TData = Awaited<ReturnType<typeof getResult>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResultParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResult>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResult>>,
          TError,
          Awaited<ReturnType<typeof getResult>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResult<TData = Awaited<ReturnType<typeof getResult>>, TError = ErrorType<unknown>>(
 params?: GetResultParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResult>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResult>>,
          TError,
          Awaited<ReturnType<typeof getResult>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResult<TData = Awaited<ReturnType<typeof getResult>>, TError = ErrorType<unknown>>(
 params?: GetResultParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResult>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResult<TData = Awaited<ReturnType<typeof getResult>>, TError = ErrorType<unknown>>(
 params?: GetResultParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResult>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResultQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetResultSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getResult>>, TError = ErrorType<unknown>>(params?: GetResultParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResult>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResultQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResult>>> = ({ signal }) => getResult(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResult>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetResultSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getResult>>>
export type GetResultSuspenseQueryError = ErrorType<unknown>


export function useGetResultSuspense<TData = Awaited<ReturnType<typeof getResult>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResultParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResult>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultSuspense<TData = Awaited<ReturnType<typeof getResult>>, TError = ErrorType<unknown>>(
 params?: GetResultParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResult>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResultSuspense<TData = Awaited<ReturnType<typeof getResult>>, TError = ErrorType<unknown>>(
 params?: GetResultParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResult>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResultSuspense<TData = Awaited<ReturnType<typeof getResult>>, TError = ErrorType<unknown>>(
 params?: GetResultParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResult>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResultSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCancelGenerationUrl = (params?: CancelGenerationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Plans/CancelGeneration?${stringifiedParams}` : `/api/Plans/CancelGeneration`
}

export const cancelGeneration = async (params?: CancelGenerationParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getCancelGenerationUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelGenerationMutationKey = () => ['cancelGeneration'] as const;

export const getCancelGenerationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelGeneration>>, TError,CancelGenerationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelGeneration>>, TError,CancelGenerationMutationVariables, TContext> => {

const mutationKey = getCancelGenerationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelGeneration>>, CancelGenerationMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  cancelGeneration(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelGenerationMutationResult = NonNullable<Awaited<ReturnType<typeof cancelGeneration>>>

    export type CancelGenerationMutationError = ErrorType<unknown>
    export type CancelGenerationMutationVariables = {params?: CancelGenerationParams}

    export const useCancelGeneration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelGeneration>>, TError,CancelGenerationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelGeneration>>,
        TError,
        CancelGenerationMutationVariables,
        TContext
      > => {
      return useMutation(getCancelGenerationMutationOptions(options), queryClient);
    }
    export const getCanPublishPlansUrl = (params?: CanPublishPlansParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Plans/CanPublishPlans?${stringifiedParams}` : `/api/Plans/CanPublishPlans`
}

export const canPublishPlans = async (params?: CanPublishPlansParams, options?: Parameters<typeof customInstance>[1]): Promise<boolean> => {

  return customInstance<boolean>(getCanPublishPlansUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCanPublishPlansQueryKey = (params?: CanPublishPlansParams,) => {
    return [
    `/api/Plans/CanPublishPlans`, ...(params ? [params] : [])
    ] as const;
    }


export const getCanPublishPlansQueryOptions = <TData = Awaited<ReturnType<typeof canPublishPlans>>, TError = ErrorType<unknown>>(params?: CanPublishPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof canPublishPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCanPublishPlansQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof canPublishPlans>>> = ({ signal }) => canPublishPlans(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof canPublishPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CanPublishPlansQueryResult = NonNullable<Awaited<ReturnType<typeof canPublishPlans>>>
export type CanPublishPlansQueryError = ErrorType<unknown>


export function useCanPublishPlans<TData = Awaited<ReturnType<typeof canPublishPlans>>, TError = ErrorType<unknown>>(
 params: undefined |  CanPublishPlansParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof canPublishPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof canPublishPlans>>,
          TError,
          Awaited<ReturnType<typeof canPublishPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCanPublishPlans<TData = Awaited<ReturnType<typeof canPublishPlans>>, TError = ErrorType<unknown>>(
 params?: CanPublishPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof canPublishPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof canPublishPlans>>,
          TError,
          Awaited<ReturnType<typeof canPublishPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCanPublishPlans<TData = Awaited<ReturnType<typeof canPublishPlans>>, TError = ErrorType<unknown>>(
 params?: CanPublishPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof canPublishPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCanPublishPlans<TData = Awaited<ReturnType<typeof canPublishPlans>>, TError = ErrorType<unknown>>(
 params?: CanPublishPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof canPublishPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCanPublishPlansQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCanPublishPlansSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof canPublishPlans>>, TError = ErrorType<unknown>>(params?: CanPublishPlansParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof canPublishPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCanPublishPlansQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof canPublishPlans>>> = ({ signal }) => canPublishPlans(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof canPublishPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type CanPublishPlansSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof canPublishPlans>>>
export type CanPublishPlansSuspenseQueryError = ErrorType<unknown>


export function useCanPublishPlansSuspense<TData = Awaited<ReturnType<typeof canPublishPlans>>, TError = ErrorType<unknown>>(
 params: undefined |  CanPublishPlansParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof canPublishPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCanPublishPlansSuspense<TData = Awaited<ReturnType<typeof canPublishPlans>>, TError = ErrorType<unknown>>(
 params?: CanPublishPlansParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof canPublishPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCanPublishPlansSuspense<TData = Awaited<ReturnType<typeof canPublishPlans>>, TError = ErrorType<unknown>>(
 params?: CanPublishPlansParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof canPublishPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCanPublishPlansSuspense<TData = Awaited<ReturnType<typeof canPublishPlans>>, TError = ErrorType<unknown>>(
 params?: CanPublishPlansParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof canPublishPlans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCanPublishPlansSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlansExportUrl = (params?: PlansExportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Plans/Export?${stringifiedParams}` : `/api/Plans/Export`
}

export const plansExport = async (params?: PlansExportParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getPlansExportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlansExportQueryKey = (params?: PlansExportParams,) => {
    return [
    `/api/Plans/Export`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlansExportQueryOptions = <TData = Awaited<ReturnType<typeof plansExport>>, TError = ErrorType<unknown>>(params?: PlansExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof plansExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlansExportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof plansExport>>> = ({ signal }) => plansExport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof plansExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlansExportQueryResult = NonNullable<Awaited<ReturnType<typeof plansExport>>>
export type PlansExportQueryError = ErrorType<unknown>


export function usePlansExport<TData = Awaited<ReturnType<typeof plansExport>>, TError = ErrorType<unknown>>(
 params: undefined |  PlansExportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof plansExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof plansExport>>,
          TError,
          Awaited<ReturnType<typeof plansExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlansExport<TData = Awaited<ReturnType<typeof plansExport>>, TError = ErrorType<unknown>>(
 params?: PlansExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof plansExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof plansExport>>,
          TError,
          Awaited<ReturnType<typeof plansExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlansExport<TData = Awaited<ReturnType<typeof plansExport>>, TError = ErrorType<unknown>>(
 params?: PlansExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof plansExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePlansExport<TData = Awaited<ReturnType<typeof plansExport>>, TError = ErrorType<unknown>>(
 params?: PlansExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof plansExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlansExportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlansExportSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof plansExport>>, TError = ErrorType<unknown>>(params?: PlansExportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof plansExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlansExportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof plansExport>>> = ({ signal }) => plansExport(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof plansExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type PlansExportSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof plansExport>>>
export type PlansExportSuspenseQueryError = ErrorType<unknown>


export function usePlansExportSuspense<TData = Awaited<ReturnType<typeof plansExport>>, TError = ErrorType<unknown>>(
 params: undefined |  PlansExportParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof plansExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlansExportSuspense<TData = Awaited<ReturnType<typeof plansExport>>, TError = ErrorType<unknown>>(
 params?: PlansExportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof plansExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlansExportSuspense<TData = Awaited<ReturnType<typeof plansExport>>, TError = ErrorType<unknown>>(
 params?: PlansExportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof plansExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePlansExportSuspense<TData = Awaited<ReturnType<typeof plansExport>>, TError = ErrorType<unknown>>(
 params?: PlansExportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof plansExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlansExportSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






